import { asyncActionCreators } from '../../utils/actions';

export const fetchContracts = asyncActionCreators('FETCH_CONTRACTS');



// WEBPACK FOOTER //
// ./src/sagas/contracts/actions.js